import React, { useState } from 'react';

const INITIAL_CTAS = [
  { id:1, name:'Club Sign-up CTA',       text:'Join as a Club →',    style:'Primary',   views:12400, clicks:1240, ctr:'10.0%', destination:'transferexpo.com/clubs/join',  created:'Jan 15, 2026', status:'Active' },
  { id:2, name:'Scout Apply CTA',        text:'Become a Scout',      style:'Secondary', views:8200,  clicks:680,  ctr:'8.3%',  destination:'transferexpo.com/scouts/apply', created:'Jan 20, 2026', status:'Active' },
  { id:3, name:'Premium Upgrade Button', text:'Upgrade to Premium ↑', style:'Accent',    views:940,   clicks:112,  ctr:'11.9%', destination:'transferexpo.com/premium',     created:'Mar 1, 2026',  status:'Active' },
  { id:4, name:'Download App CTA',       text:'Download App',        style:'Ghost',     views:3200,  clicks:284,  ctr:'8.9%',  destination:'transferexpo.com/download',    created:'Feb 10, 2026', status:'Inactive' },
];

const STYLES = ['Primary','Secondary','Accent','Ghost','Danger'];
const STYLE_PREVIEW = { Primary:{ bg:'var(--accent)', color:'#0a1a0a' }, Secondary:{ bg:'var(--bg-input)', color:'var(--text-primary)', border:'1px solid var(--border)' }, Accent:{ bg:'#4fc3f7', color:'#0a1a0a' }, Ghost:{ bg:'transparent', color:'var(--text-primary)', border:'1px solid var(--border)' }, Danger:{ bg:'#ff4d4d', color:'#fff' } };

const statusBadge = s => s==='Active'?'badge badge-green':'badge badge-gray';

export default function CTAs({ toast }) {
  const [ctas, setCtas]         = useState(INITIAL_CTAS);
  const [creating, setCreating] = useState(false);
  const [showEmbed, setShowEmbed] = useState(null);
  const [newCTA, setNewCTA]     = useState({ name:'', text:'', style:'Primary', destination:'' });

  const create = () => {
    if (!newCTA.name||!newCTA.text||!newCTA.destination) { toast?.('Fill all fields','warning'); return; }
    const c = { id:Date.now(), ...newCTA, views:0, clicks:0, ctr:'0%', created:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}), status:'Active' };
    setCtas(prev=>[...prev,c]); setCreating(false); setNewCTA({ name:'', text:'', style:'Primary', destination:'' }); toast?.('CTA created');
  };

  const embedCode = cta => `<a href="${cta.destination}" class="tf-cta tf-cta-${cta.style.toLowerCase()}" data-cta-id="${cta.id}">${cta.text}</a>\n<script src="https://js.transferexpo.com/cta/v1.js"></script>`;

  const totalClicks = ctas.reduce((s,c)=>s+c.clicks,0);
  const totalViews  = ctas.reduce((s,c)=>s+c.views,0);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total CTAs</div><div className="stat-value">{ctas.length}</div><div className="stat-sub">All buttons</div></div>
        <div className="stat-card"><div className="stat-label">Total views</div><div className="stat-value">{totalViews.toLocaleString()}</div><div className="stat-sub">Impressions</div></div>
        <div className="stat-card"><div className="stat-label">Total clicks</div><div className="stat-value">{totalClicks.toLocaleString()}</div><div className="stat-sub stat-up">All CTAs</div></div>
        <div className="stat-card"><div className="stat-label">Avg CTR</div><div className="stat-value">{totalViews?Math.round((totalClicks/totalViews)*100)+'%':'—'}</div><div className="stat-sub stat-up">Click-through</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <h3 style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:500, color:'var(--text-primary)' }}>Call-to-action buttons</h3>
        <button className="btn btn-primary" onClick={()=>setCreating(true)}>+ Create CTA</button>
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">New CTA</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setCreating(false)}>✕</button></div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>CTA name *</label><input className="search-input" value={newCTA.name} onChange={e=>setNewCTA(p=>({...p,name:e.target.value}))} placeholder="e.g. Homepage Sign-up Button" /></div>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Button text *</label><input className="search-input" value={newCTA.text} onChange={e=>setNewCTA(p=>({...p,text:e.target.value}))} placeholder="e.g. Get started →" /></div>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Style</label><select className="search-input" value={newCTA.style} onChange={e=>setNewCTA(p=>({...p,style:e.target.value}))}>{STYLES.map(s=><option key={s}>{s}</option>)}</select></div>
              <div><label style={{ fontSize:11,color:'var(--text-muted)',display:'block',marginBottom:5 }}>Destination URL *</label><input className="search-input" value={newCTA.destination} onChange={e=>setNewCTA(p=>({...p,destination:e.target.value}))} placeholder="https://..." /></div>
            </div>
            {newCTA.text && (
              <div>
                <label style={{ fontSize:11,color:'var(--text-dim)',display:'block',marginBottom:8 }}>Preview</label>
                <button style={{ padding:'10px 20px', borderRadius:8, fontSize:14, fontWeight:600, cursor:'default', ...STYLE_PREVIEW[newCTA.style] }}>{newCTA.text}</button>
              </div>
            )}
            <div style={{ display:'flex', gap:8 }}><button className="btn btn-primary" onClick={create}>Create CTA</button><button className="btn btn-ghost" onClick={()=>setCreating(false)}>Cancel</button></div>
          </div>
        </div>
      )}

      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {ctas.map(c=>(
          <div key={c.id} className="card">
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={{ display:'flex', alignItems:'center', gap:16 }}>
                <button style={{ padding:'8px 16px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'default', flexShrink:0, ...STYLE_PREVIEW[c.style] }}>{c.text}</button>
                <div>
                  <div style={{ fontWeight:500, fontSize:14, color:'var(--text-primary)', marginBottom:4 }}>{c.name}</div>
                  <div style={{ fontSize:12, color:'var(--text-dim)' }}>{c.destination}</div>
                </div>
              </div>
              <div style={{ display:'flex', gap:20, alignItems:'center' }}>
                {[['Views',c.views,'var(--text-primary)'],['Clicks',c.clicks,'var(--accent)'],['CTR',c.ctr,'#4fc3f7']].map(([label,val,color])=>(
                  <div key={label} style={{ textAlign:'center' }}>
                    <div style={{ fontWeight:700, fontSize:16, color }}>{typeof val==='number'?val.toLocaleString():val}</div>
                    <div style={{ fontSize:11, color:'var(--text-dim)' }}>{label}</div>
                  </div>
                ))}
                <span className={statusBadge(c.status)}>{c.status}</span>
                <button className="btn btn-ghost" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>setShowEmbed(c)}>{'</>'} Embed</button>
                <button className="btn btn-ghost" style={{ fontSize:11,padding:'4px 10px' }} onClick={()=>{ setCtas(prev=>prev.map(x=>x.id===c.id?{...x,status:x.status==='Active'?'Inactive':'Active'}:x)); }}>
                  {c.status==='Active'?'Deactivate':'Activate'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showEmbed && (
        <div className="modal-overlay" onClick={()=>setShowEmbed(null)}>
          <div className="modal-box" onClick={e=>e.stopPropagation()} style={{ maxWidth:560 }}>
            <div className="modal-header"><h2>Embed — {showEmbed.name}</h2><button className="modal-close" onClick={()=>setShowEmbed(null)}>✕</button></div>
            <div className="modal-body">
              <p style={{ fontSize:13,color:'var(--text-muted)',marginBottom:14 }}>Paste this code where you want the CTA button to appear on your website.</p>
              <pre style={{ background:'var(--bg-input)',padding:16,borderRadius:8,fontSize:12,color:'var(--accent)',overflowX:'auto',lineHeight:1.6,whiteSpace:'pre-wrap' }}>{embedCode(showEmbed)}</pre>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setShowEmbed(null)}>Close</button>
              <button className="btn btn-primary" onClick={()=>{ navigator.clipboard?.writeText(embedCode(showEmbed)); toast?.('Embed code copied!'); }}>Copy code</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
